module.exports = __webpack_public_path__ + "static/img/作品展示3.b277eed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/作品展示3.jpg
// module id = Z0cO
// module chunks = 2